
    <div class="wrapper">
      <div #spinner class="spinner">
        <mat-spinner color="accent"></mat-spinner>
      </div>
      <canvas #canvas id="{{canvasId}}"></canvas>
    </div>
  


// WEBPACK FOOTER //
// ./src/app/controls/preview/preview.component.ts.PreviewComponent.html